import React from "react";
import TextField from "@liveramp/motif/core/TextField";

export default function UnderlinedDemo() {
  return <TextField id="underlined-simple" variant="underlined" />;
}
